export default __webpack_public_path__ + "static/media/mid-b-9-med.50d42f5b.jpg";